import script from "./Chats.vue?vue&type=script&setup=true&lang=js"
export * from "./Chats.vue?vue&type=script&setup=true&lang=js"

import "./Chats.vue?vue&type=style&index=0&id=3afb9584&lang=scss"

const __exports__ = script;

export default __exports__